import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;

`;

export const BlockOutlet = styled.div`
  flex-grow: 1;
`;
